module.exports = __webpack_public_path__ + "img/127.834dbd80.jpg";